//@flow
import React from 'react';

import {makeStyles, TableCell, Typography} from '@material-ui/core';
import {colors} from '../../../../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  infoText: {
    color: colors.grey900,
    opacity: 0.4,
    fontWeight: 500,
    textAlign: 'center',
    fontSize: '.9rem',
  },
}));

export default function TaxesCell() {
  const classes = useStyles();
  return (
    <TableCell align="right">
      <Typography className={classes.infoText}>IGV 18%</Typography>
    </TableCell>
  );
}
